import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useGentleMotion as useReducedMotion } from '../hooks/useGentleMotion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section className="w-full bg-white py-11 sm:py-14" aria-labelledby="faq-title" data-id="element-79" data-mp="2e0zeb43ucee4">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-80" data-mp="291mm03u7af45">
        <Reveal data-id="element-81" data-mp="2924npfzmtljg">
          <h2 id="faq-title" className="text-center font-display text-2xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-82" data-mp="28ziivo44lk4x">
            Preguntas <span className="text-tangerine" data-id="element-83" data-mp="1z2xen4zxkd25">frecuentes</span>
          </h2>
        </Reveal>

        <div className="mt-7 space-y-3" data-id="element-84" data-mp="soej884lov9a">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <Reveal key={f.q} delay={i * 0.04} data-id="element-85" data-mp="phxyzdd79pqq" data-mpi={i}>
                <div className="overflow-hidden rounded-2xl border border-navy/10 bg-cream" style={{
              borderLeft: `5px solid ${['#2D8C5A', '#6CBBD5', '#F3A340', '#F27C70', '#F6C453', '#8E7CC3'][i % 6]}`
            }} data-id="element-86" data-mp="pih8q6sp57to">
                  <h3 data-id="element-87" data-mp="6rgdntup5wfe">
                    <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-cream2 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-navy" data-id="element-88" data-mp="6qwwifcvfc2f">
                      <span className="font-display text-sm font-extrabold uppercase leading-snug text-navy sm:text-base" data-id="element-89" data-mp="3o03bscry6jdh">
                        {f.q}
                      </span>
                      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-90" data-mp="1pq4jmpri2kz1">
                        {isOpen ? <MinusIcon className="h-4 w-4 text-brandgreen" aria-hidden="true" data-id="element-91" data-mp="1krt4q0mclk9y" /> : <PlusIcon className="h-4 w-4 text-brandgreen" aria-hidden="true" data-id="element-92" data-mp="1fpvhyweqo7c9" />}
                      </span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-93" data-mp="28ej7j46itivm">
                    {isOpen && <motion.div id={`faq-panel-${i}`} initial={reduce ? undefined : {
                  height: 0,
                  opacity: 0
                }} animate={reduce ? undefined : {
                  height: 'auto',
                  opacity: 1
                }} exit={reduce ? undefined : {
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.28,
                  ease: [0.22, 1, 0.36, 1]
                }} className="overflow-hidden" data-id="element-94" data-mp="23fy8v96x379a">
                        <p className="px-5 pb-5 font-sans text-sm leading-relaxed text-muted" data-id="element-95" data-mp="33qisv6mxk0uy">
                          {f.a}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </div>

      </div>
    </section>;
}